import { Form, Tabs } from 'antd';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Div } from 'ui';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import AnnouncementTabPane from './announcement-tab-pane';
import { standaloneTabKeys } from '../../../utils/app-configs';

const Title = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    font-weight: bold;
    text-transform: uppercase;
  }

  .ant-tabs-bar {
    margin: 0 !important;
  }

  .ant-tabs-tab {
    font-weight: 400;
    text-transform: uppercase;
    width: 110px;
    justify-content: center;
  }

  .ant-tabs-ink-bar {
    background: ${p => p.theme.colors.theme} !important;
  }

  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      color: ${p => p.theme.colors.theme} !important;
    }
  }
`;

const ActiveIcon = styled(CheckCircleOutlined)`
  color: ${p => p.theme.colors.alerts[4]};
  margin-left: 5px;
  margin-right: 0;
`;

const ErrorIcon = styled(ExclamationCircleOutlined)`
  color: ${p => p.theme.colors.alerts[1]};
  margin-left: 5px;
  margin-right: 0;
`;

const AnnouncementsForStandalone = ({ intl, form, disabled, subErrors }) => <>
  <Title>{intl.formatMessage({ id: 'standaloneMode.ANNOUNCEMENTS_TITLE' })}</Title>
  <StyledTabs
    defaultActiveKey='before'
    items={Object.values(standaloneTabKeys)?.map((tabKey) => {
      const isShown = Form.useWatch([`${tabKey}`, 'isShown'], form);
      const isTurnedOn = Form.useWatch('isTurnedOn', form);

      const hasError = subErrors.some((error) => {
        const { name } = error;
        return Array.isArray(name) && name.includes(tabKey);
      });
      const shouldRenderActiveIcon = isTurnedOn && isShown && !hasError;

      return {
        key: tabKey,
        label: <Div>
          {intl.formatMessage({ id: `standaloneMode.${tabKey.toUpperCase()}` })}
          {hasError && <ErrorIcon />}
          {shouldRenderActiveIcon && <ActiveIcon />}
        </Div>,
        forceRender: true,
        children: <AnnouncementTabPane tabKey={tabKey} form={form} disabled={disabled} />,
      };
    })}
  />
</>;

AnnouncementsForStandalone.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  disabled: PropTypes.bool,
  subErrors: PropTypes.array,
};


export default injectIntl(AnnouncementsForStandalone);
